<div class="one-whole-adfspro ml-adfspro">
    <h2 class="heading-adfspro">{{'ADFS Profiles'|translate}}</h2>
    <p class="p-adfspro">{{'Configured ADFS connection profiles'|translate}}</p>
    <div class="one-whole-adfspro">
        <div><input class="btn-adfspro addadfsprobtn" (click)="addAdfspro(addadfsprofile)" type="button" value="{{'ADD'|translate}}">
        </div>
        <table class="table__thin tablesorter table">
            <thead class="table__headings">
                <tr>
                    <th class="cid-w-adfspro">{{'Origin'|translate}}</th>
                    <th class="cid-w-adfspro">{{'User Type'|translate}}</th>
                    <th class="cid-w-adfspro">{{'Redirect URL'|translate}}</th>
                    <th class="cid-w-adfspro">{{'Resource'|translate}}</th>
                    <th class="cid-w-adfspro">{{'Client ID'|translate}}</th>
                    <th class="cid-w-adfspro"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let i of adfsproList;">
                    <td>{{i.origin}}</td>
                    <td>{{i.userType}}</td>
                    <td>{{i.redirectUrl}}</td>
                    <td>{{i.resource}}</td>
                    <td>{{i.clientId}}</td>
                    <td class="buttontd-adfspro">
                        <input class="btn-adfspro" (click)="editAdfsprodata(i.profileId,i.origin,
                        i.userType,i.redirectUrl,i.resource,i.clientId,i.logoutUrl,editAdfsproCredentials)"
                            type="button" value="{{'EDIT'|translate}}">&nbsp;
                        <input class="btn-adfspro" (click)="deleteAdfsprodata(i.profileId,deletePopUpAdfspro)"
                            type="button" value="{{'DELETE'|translate}}">
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<div class="modal-dialog modal-lg">
    <ng-template #addadfsprofile let-modal>
        <div class="popup-border-adfspro">
            <div class="modal-header-adfspro">
                <span class="header-popup-text-adfspro">{{'Add new ADFS Connection profile'|translate}}</span>
                <i class="fa fa-times mng-qualifier-close-btn close-adfspro-popup"
                    (click)="modal.dismiss('Cross click');clearVariablesAdfspro()" title="close"></i>
            </div>
            <div class="input-box-adfspro">                
                <div *ngIf="errorunabletoperform" class="error-adfs-border">
                    <span class="fa fa-exclamation-triangle"></span>&nbsp;
                    <span class="adderror-adfspro">{{'Unable to perform action'|translate}}</span>
                </div>
                <div *ngIf="profilealreadypresent" class="error-adfs-border">
                    <span class="fa fa-exclamation-triangle"></span>&nbsp;
                    <span class="adderror-adfspro">{{'There must be only one profile'|translate}}</span>
                </div>
                {{'Origin'|translate}}
                <input type="text" class="pop-w-input-adfspro" name="adfsprooriginAdd" [(ngModel)]="adfsprooriginAdd">
                <div *ngIf="erroradfsproOrigin" class="error-adfs-border">
                    <span class="fa fa-exclamation-triangle"></span>&nbsp;
                    <span class="adderror-adfspro">{{'Origin is missing'|translate}}</span>
                </div>
                {{'User Type'|translate}}
                <select name="adfsprousertypeAdd" [(ngModel)]="adfsprousertypeAdd" class="pop-w-input-adfspro"
                    id="adfsprousertypeAdd">
                    <option value="STAFF">{{'STAFF'|translate}}</option>
                    <option value="AUTHORIZED">{{'AUTHORIZED'|translate}}</option>
                </select>
                <div *ngIf="erroradfsprousertype" class="error-adfs-border">
                    <span class="fa fa-exclamation-triangle"></span>&nbsp;
                    <span class="adderror-adfspro">{{'User type is missing'|translate}}</span>
                </div>
                {{'Redirect URL'|translate}}
                <input type="text" class="pop-w-input-adfspro" name="adfsproredirecturlAdd"
                    [(ngModel)]="adfsproredirecturlAdd">
                <div *ngIf="erroradfsproredirecturl" class="error-adfs-border">
                    <span class="fa fa-exclamation-triangle"></span>&nbsp;
                    <span class="adderror-adfspro">{{'Redirect URL is missing'|translate}}</span>
                </div>
                {{'Resource'|translate}}
                <input type="text" class="pop-w-input-adfspro" name="adfsproresourceAdd"
                    [(ngModel)]="adfsproresourceAdd">
                <div *ngIf="erroradfsproresource" class="error-adfs-border">
                    <span class="fa fa-exclamation-triangle"></span>&nbsp;
                    <span class="adderror-adfspro">{{'Resource is missing'|translate}}</span>
                </div>
                {{'Client ID'|translate}}
                <input type="text" class="pop-w-input-adfspro" name="adfsproclientidAdd"
                    [(ngModel)]="adfsproclientidAdd">
                <div *ngIf="erroradfsproclientid" class="error-adfs-border">
                    <span class="fa fa-exclamation-triangle"></span>&nbsp;
                    <span class="adderror-adfspro">{{'Client ID is missing'|translate}}</span>
                </div>
                {{'Logout URL'|translate}}
                <input type="text" class="pop-w-input-adfspro" name="adfsprologouturlAdd"
                    [(ngModel)]="adfsprologouturlAdd">
                <div *ngIf="erroradfsprologouturl" class="error-adfs-border">
                    <span class="fa fa-exclamation-triangle"></span>&nbsp;
                    <span class="adderror-adfspro">{{'Logout URL is missing'|translate}}</span>
                </div>
            </div>
            <div class="modal-footer">
                <input class="input-btn-adfspro" type="button" value="{{'SUBMIT'|translate}}" (click)="setsubmiteditadfsproAdd(adfsprooriginAdd,adfsprousertypeAdd,
                adfsproredirecturlAdd,adfsproresourceAdd,adfsproclientidAdd,adfsprologouturlAdd)">
                &nbsp;&nbsp;<input class="input-btn-adfspro" type="button" value="{{'CLOSE'|translate}}"
                    (click)="modal.close('Close click');clearVariablesAdfspro();">
            </div>
        </div>
    </ng-template>
</div>
<div class="modal-dialog modal-lg">
    <ng-template #editAdfsproCredentials let-modal>
        <div class="popup-border-adfspro">
            <div class="modal-header-adfspro">
                <span class="header-popup-text-adfspro">{{'Edit existing ADFS Connection profile'|translate}}</span>
                <i class="fa fa-times mng-qualifier-close-btn close-adfspro-popup"
                    (click)="modal.dismiss('Cross click');clearVariablesAdfspro()" title="close"></i>
            </div>
            <div class="input-box-adfspro">
                <div *ngIf="profilealreadypresent" class="error-adfs-border">
                    <span class="fa fa-exclamation-triangle"></span>&nbsp;
                    <span class="adderror-adfspro">{{'There must be only one profile'|translate}}</span>
                </div>
                {{'Origin'|translate}}
                <input type="text" class="pop-w-input-adfspro" name="adfsprooriginUp" 
                [(ngModel)]="adfsprooriginUp">
                <div *ngIf="erroradfsproOriginUp" class="error-adfs-border">
                    <span class="fa fa-exclamation-triangle"></span>&nbsp;
                    <span class="adderror-adfspro">{{'Origin is missing'|translate}}</span>
                </div>
                {{'User Type'|translate}}
                <select name="adfsprousertypeUp" [(ngModel)]="adfsprousertypeUp" class="pop-w-input-adfspro"
                    id="adfsprousertypeUp">
                    <option value="STAFF">{{'STAFF'|translate}}</option>
                    <option value="AUTHORIZED">{{'AUTHORIZED'|translate}}</option>
                </select>
                <div *ngIf="erroradfsprousertypeUp" class="error-adfs-border">
                    <span class="fa fa-exclamation-triangle"></span>&nbsp;
                    <span class="adderror-adfspro">{{'User type is missing'|translate}}</span>
                </div>
                {{'Redirect URL'|translate}}
                <input type="text" class="pop-w-input-adfspro" name="adfsproredirecturlUp"
                    [(ngModel)]="adfsproredirecturlUp">
                <div *ngIf="erroradfsproredirecturlUp" class="error-adfs-border">
                    <span class="fa fa-exclamation-triangle"></span>&nbsp;
                    <span class="adderror-adfspro">{{'Redirect URL is missing'|translate}}</span>
                </div>
                {{'Resource'|translate}}
                <input type="text" class="pop-w-input-adfspro" name="adfsproresourceUp" [(ngModel)]="adfsproresourceUp">
                <div *ngIf="erroradfsproresourceUp" class="error-adfs-border">
                    <span class="fa fa-exclamation-triangle"></span>&nbsp;
                    <span class="adderror-adfspro">{{'Resource is missing'|translate}}</span>
                </div>
                {{'Client ID'|translate}}
                <input type="text" class="pop-w-input-adfspro" name="adfsproclientidUp" [(ngModel)]="adfsproclientidUp">
                <div *ngIf="erroradfsproclientidUp" class="error-adfs-border">
                    <span class="fa fa-exclamation-triangle"></span>&nbsp;
                    <span class="adderror-adfspro">{{'Client ID is missing'|translate}}</span>
                </div>
                {{'Logout URL'|translate}}
                <input type="text" class="pop-w-input-adfspro" name="adfsprologoutUrlUp"
                    [(ngModel)]="adfsprologoutUrlUp">
                <div *ngIf="erroradfsprologouturlUp" class="error-adfs-border">
                    <span class="fa fa-exclamation-triangle"></span>&nbsp;
                    <span class="adderror-adfspro">{{'Logout URL is missing'|translate}}</span>
                </div>
            </div>
            <div class="modal-footer">
                <input class="input-btn-adfspro" type="button" value="{{'SUBMIT'|translate}}" (click)="setsubmiteditadfsproedit(adfsprooriginUp,adfsprousertypeUp,adfsproredirecturlUp,
                adfsproresourceUp,adfsproclientidUp,adfsprologoutUrlUp)">
                &nbsp;&nbsp;<input class="input-btn-adfspro" type="button" value="{{'CLOSE'|translate}}"
                    (click)="modal.close('Close click');clearVariablesAdfspro()">
            </div>
        </div>
    </ng-template>
</div>
<div class="modal-dialog modal-sm">
    <ng-template #deletePopUpAdfspro let-modal>
        <div class="popup-border-adfspro">
            <div class="modal-header-adfspro">
                {{'Delete Profile'|translate}}
                <i class="fa fa-times mng-qualifier-close-btn close-adfspro-popup"
                    (click)="modal.dismiss('Cross click');clearVariablesAdfspro()" title="close"></i>
            </div>
            <div class="padding-adfspro">
                <label>{{'Are you sure you want to delete this profile'|translate}}</label>
            </div>
            <div class="modal-footer">
                <input class="input-btn-adfspro" type="button" value="{{'Ok'|translate}}"
                    (click)="modal.dismiss('deletePopUpAdfspro');deletePopcredentialAdfspro();">
                &nbsp;&nbsp;
                <input class="input-btn-adfspro" type="button" value="{{'CLOSE'|translate}}"
                    (click)="modal.close('Close click');clearVariablesAdfspro()">
            </div>
        </div>
    </ng-template>
</div>
<div *ngIf="isBackToTopShowBtn" (scroll)="onScroll($event)" class="back-to-top-adfspro" style="display: block;"
    (click)="topFunction()">